<template>
    <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" @click:outside="cancel">
        <v-card>
            <v-toolbar dark :color="options.color" dense flat>
                <v-toolbar-title class="text-body-1 font-weight-bold white--text">
                    {{ title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text v-show="!!message" class="pa-4 black--text" v-html="message"></v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn v-if="!options.noconfirm" color="grey" text class="body-2 font-weight-bold" @click.native="cancel">Cancelar</v-btn>
                <v-btn color="primary" class="body-2 font-weight-bold" @click.native="agree">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
svg.loader {
    width: 128px;
    height: 128px;
    margin: 0px;
    display: inline-block;
}
</style>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
    dialog = false;
    resolve: ((value: boolean) => void) | null = null;
    reject: ((value: boolean) => void) | null = null;
    message: string | null = null;
    title: string | null = null;
    options = {
        color: "#2B3848",
        width: 400,
        zIndex: 200,
        noconfirm: false,
    };

    open(title: string, message: string, options?: any) {
        this.dialog = true;
        this.title = title;
        this.message = message;
        if (options) {
            this.options = Object.assign(this.options, options);
        }
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    agree() {
        if (this.resolve) {
            this.resolve(true);
        }

        this.dialog = false;
    }

    cancel() {
        if (this.resolve) {
            this.resolve(false);
        }
        this.dialog = false;
    }
}
</script>
